(function($){
    'use strict';
    // tabbed content
    // http://www.entheosweb.com/tutorials/css/tabs.asp

    /* if in tab mode */

    $('ul.tabs li a').click(function (e) { 
        e.preventDefault(); 
    });

    $('ul.tabs li').click(function () { 

        $(this).parent().parent().find('.tab_content').removeClass('tActive');
        var activeTab = $(this).attr('rel');
        $('#' + activeTab).addClass('tActive');
        $(this).parents('.tabs').find('li').removeClass('active');
        $(this).addClass('active');

        $('.tab_drawer_heading')
            .removeClass('dActive')
            .find('span.pull-right')
            .removeClass('icon-chevron-up')
            .addClass('icon-chevron-down');

        $('.tab_drawer_heading[rel^="' + activeTab + '"]')
            .addClass('dActive')
            .find('span.pull-right')
            .removeClass('icon-chevron-down')
            .addClass('icon-chevron-up');
            
        $(this).parent().parent().find('.tab_content').removeClass('dActive');
        $('#' + activeTab).addClass('dActive');
    });
    /* if in drawer mode */
    $('.tab_drawer_heading').click(function () {

        var dActiveTab = $(this).attr('rel');
        $('#' + dActiveTab).toggleClass('dActive');
        $(this).toggleClass('dActive');
        if ($(this).hasClass('dActive')){
            $(this).find('span.pull-right').removeClass('icon-chevron-down').addClass('icon-chevron-up');
        } else {
            $(this).find('span.pull-right').removeClass('icon-chevron-up').addClass('icon-chevron-down');
        }
        $(this).parent().parent().find('ul.tabs li').removeClass('active');
        $('ul.tabs li[rel^="' + dActiveTab + '"]').addClass('active');

        $(this).parent().find('.tab_content').removeClass('tActive');
        $('#' + dActiveTab).addClass('tActive');
    });
    /* Extra class 'tab_last' */
    $('ul.tabs li').last().addClass('tab_last');

    var tabNumbers = $('ul.tabs li').length;
    var removedCounter = 0;
    for(var i=1; i<=tabNumbers;i=i+1) {
        if ($('#tab'+i).length) {
            if ($('#tab'+i).html().replace(/<br *\/*>|\s|\r\n|\r|\n/i, '').replace(/<[^\/>][^>]*><\/[^>]+>/
, '').trim() === '') {
                $('#tab'+i).remove();
                $('.tab_drawer_heading[rel=tab'+i+']').remove();
                $('#tabHead'+i).remove();
                removedCounter = removedCounter + 1;
            }
        }
    }


    if (removedCounter === tabNumbers) {
        $('.product-tabs.tab_container').remove();
        $('.product-tabs.tabs').remove();
    }
   

    $('.tab_content').removeClass('tActive');
    $('.tab_content:first-of-type').addClass('tActive');
    $('.tabs li:first-child').addClass('active');




}(jQuery));